import BaseApi from '../base/base'
export interface PracticeStatus { id?: string; status: 'generating' | 'ready' | 'failed'; examId?: number; userExamId?: number; focus?: string; message?: string; progress?: number; stage?: string }
export interface PracticeSettings {
  version: number
  defaultAgentId?: number | null
  check: { style: 'adaptive' | 'quiz' | 'interview'; maxAnswers: number; completion: 'adaptive' | 'fixed' }
  comprehensive: { questionCount: number; format: string; timeLimitMinutes: number; showButton?: boolean; chatTrigger?: string }
  focused: { questionCount: number; format: string; timeLimitMinutes: number }
  fingerprints: { check: string; comprehensive: string; focused: string }
}
export interface PracticeHistoryItem { examId: number; userExamId: number; title: string; focus: string; createdAt: string; status: 'ready' | 'started' | 'finished'; score: number | null }
export interface PracticeHistoryPage { items: PracticeHistoryItem[]; nextCursor: number | null }
export default class LessonPracticeApi extends BaseApi {
  async settings(lessonId: number, courseId: number): Promise<PracticeSettings> {
    this.path = `/lessons/${lessonId}/practice_settings`
    return (await this.getRequest({ courseId }, false)).data
  }
  async ensureExamSession(lessonId: number, courseId?: number) {
    this.path = `/lessons/${lessonId}/exam_session`
    return (await this.postRequest({ courseId })).data
  }
  async history(lessonId: number, beforeId?: number, courseId?: number): Promise<PracticeHistoryPage> {
    this.path = `/lessons/${lessonId}/practice_exams`
    return (await this.getRequest({ beforeId, courseId }, false)).data
  }
  async create(lessonId: number, threadId: string, mode: 'focused' | 'comprehensive' = 'focused', agentId?: number | string, courseId?: number, settingsFingerprint?: string, requestId?: string): Promise<PracticeStatus> {
    this.path = `/lessons/${lessonId}/practice_exams`
    return (await this.postRequest({ threadId, mode, agentId, courseId, settingsFingerprint, requestId })).data
  }
  async dialog(lessonId: number, data: { threadId: string; agentId: number | string; dialogAction: string; courseId?: number; settingsFingerprint?: string; content?: string; replyToId?: number; userExamId?: number; activeView?: object }) {
    this.path = `/lessons/${lessonId}/practice_dialog`
    return (await this.postRequest(data)).data
  }
  async status(lessonId: number, id: string, courseId?: number): Promise<PracticeStatus> {
    this.path = `/lessons/${lessonId}/practice_exams/${id}`
    return (await this.getRequest({ courseId }, false)).data
  }
}
